import { render } from "./보건증.vue?vue&type=template&id=28b7b712"
import script from "./보건증.vue?vue&type=script&lang=js"
export * from "./보건증.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__